<div class="ap-container">
  <h2 class="ap-pl-spacing-4">{{ 'admin.title' | translate }}</h2>
  <div class="w-100">
    <ul class="admin-card-list">
      @for (item of adminMenuItems; track $index) {
        <li class="admin-card ap-p-spacing-4">
          <gstar-card
            [title]="item.titleTranslateKey | translate"
            [icon]="item.icon"
            (click)="itemClick(item)">
            {{ item.descriptionTranslateKey | translate }}
          </gstar-card>
        </li>
      }
    </ul>
  </div>
</div>
